var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9277 11.1719H13.9277V5.17188C13.9277 4.61888 13.4797 4.17188 12.9277 4.17188C12.3757 4.17188 11.9277 4.61888 11.9277 5.17188V11.1719H5.92773C5.37573 11.1719 4.92773 11.6189 4.92773 12.1719C4.92773 12.7249 5.37573 13.1719 5.92773 13.1719H11.9277V19.1719C11.9277 19.7249 12.3757 20.1719 12.9277 20.1719C13.4797 20.1719 13.9277 19.7249 13.9277 19.1719V13.1719H19.9277C20.4797 13.1719 20.9277 12.7249 20.9277 12.1719C20.9277 11.6189 20.4797 11.1719 19.9277 11.1719Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6224_17262",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 17,
    height: 17
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9277 11.1719H13.9277V5.17188C13.9277 4.61888 13.4797 4.17188 12.9277 4.17188C12.3757 4.17188 11.9277 4.61888 11.9277 5.17188V11.1719H5.92773C5.37573 11.1719 4.92773 11.6189 4.92773 12.1719C4.92773 12.7249 5.37573 13.1719 5.92773 13.1719H11.9277V19.1719C11.9277 19.7249 12.3757 20.1719 12.9277 20.1719C13.4797 20.1719 13.9277 19.7249 13.9277 19.1719V13.1719H19.9277C20.4797 13.1719 20.9277 12.7249 20.9277 12.1719C20.9277 11.6189 20.4797 11.1719 19.9277 11.1719Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6224_17262)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.d959fd842660ada48b65289c5d658c94.svg";
export { ForwardRef as ReactComponent };